import { CommonDropDown } from '../../common/types/dropdown.type';

export interface IUsers {
    id: number,
    firstName: string,
    lastName: string,
    address: string,
    birthDate: Date,
    joinDate: Date,
    panNumber: string,
    aadhaarNumber: string,
    avatar?: string,
    userName: string,
    email: string,
    password: string,
    roleName: string,
    phoneNumber: string;
    specialityId?: number;
    degree?: string;
    registrationNumber?: string;
    hprId?: string;
    name?: string;
}

export type DoctorInfo = Pick<
    IUsers,
    'id' | 'firstName' | 'lastName' | 'phoneNumber' | 'specialityId' |
    'degree' | 'registrationNumber' | 'name'
>;

export function toDoctorInfo(doctor: CommonDropDown): DoctorInfo {
    return {
        id: doctor.id,
        firstName: doctor.firstName ?? '',
        lastName: doctor.lastName ?? '',
        phoneNumber: doctor.phoneNumber ?? '',
        specialityId: doctor.specialityId,
        degree: doctor.degree,
        registrationNumber: doctor.registrationNumber,
        name: doctor.name
        
    };
}

export interface UserAvalibility {
    [x: string]: any;
    userId: number,
    day: string,
    startTime: string,
    endTime: string,
    isActive: boolean;
}

export interface UserAvailabilityPayload {
  userId: number;
  userAvailabilities: UserAvalibility[];
}
